<template>
  <div class="navbar-container sticky top-0 z-30">
    <nuxt-link to="/">
      <div class="navbar-brand">
        <img v-lazy-load data-src="@/assets/icon/icon-new-yd.svg" alt="" width="131" height="56">
      </div>
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: 'YesNavbarClassic'
}
</script>

<style scoped lang="scss">
$primary: #1a5cac;
$white: #fff;
.navbar-container {
  background-color: $white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: .5rem 1rem;
  color: $primary;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);

  .navbar-brand {
    display: flex;
    align-items: center;
  }
}
</style>
